export type SupportTopicMetadata = {
  id: string;
  namePath: string;
  productFamily: string;
  state: TopicState;
  metadata: TopicMetadata;
  cosmicMapping?: CosmicMapping;
  diagnostics: Diagnostic[];
  partCConnectorInfo: PartCConnectorInfo[];
};

export type TopicMetadata = {
  category: Category[];
  ipdOwner: string;
  supportabilityPM: string;
  devOpsAreaPath: string;
  reportingTopic: string;
  authenticationStep: AuthenticationStep;
  allowTicketCreationInPC: AllowTicketCreationInPC;
  allowGuestTicketCreationInPC: AllowGuestTicketCreationInPC;
  ticketingSystem: TicketingSystem;
  reportingProgram: ReportingProgram;
  enabledSupportOptionsInPC: EnabledSupportOptionsInPC[];
  workspace: any[];
  workspaceCategory: any[];
  partCConnectorPaths: any[];
};

export type CosmicMapping = {
  lineOfBusinessId: string;
  programIdProd: string;
  programIdPpe: string;
  caseSubtypeId: string;
  caseReasonId: string;
  caseSubreasonId: string;
};

export type PartCConnectorInfo = {
  path: string;
  state: GenericState;
  icmPath: string;
  owner: string;
  description: string;
};

export type Diagnostic = {
  name: string;
  state: GenericState;
  source: string;
  type: DiagnosticType;
  owner: string;
  icmPath: string;
};

export enum DiagnosticType {
  None = 'None',
  Endpoint = 'Endpoint',
  JSConnector = 'JSConnector',
}

export enum GenericState {
  Preview = 'Preview',
  Live = 'Live',
}

export enum TopicState {
  None = 'None',
  Preview = 'Preview',
  Live = 'Live',
  Retired = 'Retired',
}

export enum AuthenticationStep {
  None = 'None',
  Unauthenticated = 'Unauthenticated',
  Solutions = 'Solutions',
  Details = 'Details',
}

export enum AllowTicketCreationInPC {
  None = 'None',
  Blocked = 'Blocked',
  Unblocked = 'Unblocked',
  BlockedWithDuplicateCheck = 'BlockedWithDuplicateCheck',
  UnblockedWithDuplicateCheck = 'UnblockedWithDuplicateCheck',
}

export enum AllowGuestTicketCreationInPC {
  None = 'None',
  Blocked = 'Blocked',
  Unblocked = 'Unblocked',
}

export enum TicketingSystem {
  None = 'None',
  ServiceDesk = 'DfM',
  Cosmic = 'Cosmic',
  Snow = 'Snow',
}

export enum EnabledSupportOptionsInPC {
  Web = 'Web',
  Phone = 'Phone',
  Chat = 'Chat',
}

export enum ProductFamilies {
  PartnerCenter = '08c1ce1a-b1e0-6acc-d1e6-c2420d3c1fc1',
  MSX = 'b0630064-5cda-cad9-0da6-8d9790ef81b1',
}
export function GetDropdownByProductFamily(productFamilyId: string) {
  switch (productFamilyId) {
    case ProductFamilies.PartnerCenter:
      return WorkspaceAndWCategoryPC;
    case ProductFamilies.MSX:
      return WorkspaceAndWCategoryMSX;
    default:
      return null;
  }
}

export function GetWorkspace(productFamilyId: string) {
  switch (productFamilyId) {
    case ProductFamilies.PartnerCenter:
      return WorkspacePC;
    case ProductFamilies.MSX:
      return WorkspaceMSX;
    default:
      return null;
  }
}

export function GetWorkspaceCategory(productFamilyId: string) {
  switch (productFamilyId) {
    case ProductFamilies.PartnerCenter:
      return WorkspaceCategoryPC;
    case ProductFamilies.MSX:
      return WorkspaceCategoryMSX;
    default:
      return null;
  }
}

export function GetReportingProgram(productFamilyId: string) {
  switch (productFamilyId) {
    case ProductFamilies.PartnerCenter:
      return ReportingProgram;
    case ProductFamilies.MSX:
      return ReportingProgramMSX;
    default:
      return null;
  }
}

export enum WorkspaceMSX {
  None = 'None',
  Leads = 'leads',
  AccountPlans = 'accountPlans',
  Accounts = 'accounts',
  Contacts = 'contacts',
  Engagements = 'engagements',
  Opportunities = 'opportunities',
  Partners = 'partners',
  Proposals = 'proposals',
  DealAssistance = 'dealAssistance',
  Compensation = 'compensation',
  CALC = 'calc',
  SalesAccelerator = 'salesaccelerator',
}

export enum WorkspaceCategoryMSX {
  None = 'None',
  UserProvisioning = 'userProvisioning',
}

export enum WorkspacePC {
  None = 'None',
  AppsAndGames = 'rr3q88o',
  Benefits = '2t2b7h0',
  Billing = 'oygi8p5',
  Collaborate = '8ukjom7',
  Customers = 'jtq6njt',
  Edge = '44xvqci',
  Hardware = '6z0naak',
  Incentives = 'xjayl89',
  Insights = 'lks5q3i',
  Membership = '29543yy',
  MarketplaceOffers = 'zp6h43v',
  Referrals = 'kwo9p6l',
  Earnings = '227z4kg',
  Pricing = '236bzx2',
  HelpAndSupport = 'ck2ic0y',
}

export enum WorkspaceCategoryPC {
  None = 'None',
  AccountSettings = 'a4h83dj',
  ActionCenter = 'd8hwe3j',
  ApisAndIntegration = 'pm7xssm',
  Enrollment = 'wr1s1fg',
}

export const WorkspaceAndWCategoryMSX = { ...WorkspaceMSX, ...WorkspaceCategoryMSX };

export const WorkspaceAndWCategoryPC = { ...WorkspacePC, ...WorkspaceCategoryPC };

export enum Category {
  Csp = 'Csp',
  Mpn = 'Mpn',
  Incentives = 'Incentives',
  Referrals = 'Referrals',
  Isv = 'Isv',
  General = 'General',
  DeveloperTools = 'DeveloperTools',
  MicrosoftDynamics = 'MicrosoftDynamics',
  ProductSupport = 'ProductSupport',
  VolumeLicensing = 'VolumeLicensing',
}

// TODO: can we read this from the schema file so that we dont have to modify anything
export enum ReportingProgram {
  None = 'None',
  Csp = 'Csp',
  Mpn = 'Mpn',
  Incentives = 'Incentives',
  Marketplace = 'Marketplace',
  General = 'General',
  OtherPortals = 'OtherPortals',
  PartnerVetting = 'PartnerVetting',
  Referrals = 'Referrals',
  SupplyChain = 'SupplyChain',
}

export enum ReportingProgramMSX {
  None = 'None',
  Seller = 'Seller',
}
